import React from 'react'
import { canDownloadDailySettlementControl } from '../../global_context/capabilities/settlementCapabilities'
import { SETTLEMENT_INDEX_TAB } from '../constants/constants'
import SettlementsPageLayout from '../SettlementsPageLayout'
import DailySettlementControlTab from './DailySettlementControlTab'

export default function DailySettlementControlApp() {
  return (
    <SettlementsPageLayout activeTab={SETTLEMENT_INDEX_TAB.DAILY}>
      <DailySettlementControlTab canDownload={canDownloadDailySettlementControl()} />
    </SettlementsPageLayout>
  )
}
